import React from "react";
import ActivityAction from "../ActivityAction/ActivityAction";

const MoveActivityItem = ({ isDocument, document, isFolder, folder, openFolder, previousFolder, hasAccess }) => (
  <>
    moved {isDocument ? document.title : isFolder ? folder.title : ""} from {previousFolder} to
    <ActivityAction
      {...{
        onClick: () => openFolder(folder),
        title: folder?.title,
        isFolder: true,
        inTrash: folder?.inTrash,
        hasAccess,
      }}
    />
  </>
);

export default MoveActivityItem;
